import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {Link} from 'arag-ui-lib';
import '../style/generalTab.css'
import PolicyTabWording from "./ApplicationPolicy/policyTabWording";
import PolicyTabSchedule from "./ApplicationPolicy/policyTabSchedule";
import CenteredDots from "./General/centeredDots";
import FormResponseMessage from "./formResponseMessage";
import GplWordingModal from "./ApplicationPolicy/gplWordingModal";
import {downLoadFile, isGatewayPlutusLawsys} from "../helpers/functions";
import { CANADA_COUNTRY, COUNTRY } from '../helpers/variables';
import { PRE_LIVE_POLICY_STATUSES, TERTIARY } from '../helpers/constants';

const PolicyTab = (props) => {
    const [isWordingModalOpen, setWordingModalOpen] = useState(false);
    const gplDocuments = useSelector(state => state.gplPolicyDocuments);
    const isGpl = isGatewayPlutusLawsys(props.selectedApp?.systemsOfRecordId);

    if (
        props.fetchingSchedules ||
        props.fetchingIpt ||
        props.fetchingUnderwriter ||
        props.fetchingSolicitorDetails ||
        props.fetchingPremiumSettings ||
        props.fetchingWording
    ) {
        return (
            <CenteredDots/>
        )
    }

    if (PRE_LIVE_POLICY_STATUSES.includes(props.selectedApp.policyStatusMachineName)) {
        return null;
    }

	return (
		<div className="generalTab-wrapper">
            {
                props.haveDataRequired && (
                    <PolicyTabSchedule
                        downloadPolicySchedule={props.downloadPolicySchedule}
                        applicationPolicyTrack={props.applicationPolicyTrack}
                        fetchingSchedules={props.fetchingSchedules}
                        fetchingIpt={props.fetchingIpt}
                        fetchingUnderwriter={props.fetchingUnderwriter}
                        fetchingSolicitorDetails={props.fetchingSolicitorDetails}
                        fetchingPremiumSettings={props.fetchingPremiumSettings}
                        haveDataRequired={props.haveDataRequired}
                        groupRangesOfDamages={props.groupRangesOfDamages}
                        ipt={props.ipt}
                        schedules={props.schedules}
                        underwriterName={props.policy.underwriterName}
                        footer={props.footer}
                        findQuestionAnswer={props.findQuestionAnswer}
                        applicationPremiumSettings={props.applicationPremiumSettings}
                        selectedApp={props.selectedApp}
                        lawsysFirm={props.lawsysFirm}
                        allPossibleDamages = {props.allPossibleDamages}
                        fetchingPolicy = {props.fetchingPolicySchedule}
                    />
                )
            }
            {
                isGpl && (
                    <div className="col-sm-12 generalTab-wrapper gplWording-openLink">
                        {/* AC3: GPL policies hide the per-policy wording and IPID downloads and
                            offer the GPL policy document set instead. */}
                        <Link
                            label="Click here to download your client's policy wording and IPID"
                            variant={TERTIARY}
                            onClick={() => setWordingModalOpen(true)}
                            linkTestId="gpl-wording-open-link"
                        />
                    </div>
                )
            }
            {
                !isGpl && !props.failedToGetWordingMsg && (
                    <div>
                        <PolicyTabWording
                            handleClick={props._downloadWording}
                            wordingFile={{name: `${props.wording.name}`}}
                            policyLiveDate={props.policy.liveDate}
                            aragReference={props.policy.aragReference}
                        />
                    {COUNTRY !== CANADA_COUNTRY &&
                        <PolicyTabWording
                            handleClick={() => downLoadFile(props.wording.ipidName, props.wording.ipidEncodedFile)}
                            wordingFile={{name: `${props.wording.ipidName}`}}
                            policyLiveDate={props.policy.liveDate}
                            aragReference={props.policy.aragReference}
                        />}
                    </div>
                )
            }
            {
                !isGpl && props.failedToGetWordingMsg && (
                    <FormResponseMessage
                        Message={props.failedToGetWordingMsg}
                        CenterWrapper="col-sm-12 mb-15 mt-15"
                        MessageStyle="formResponseMessage-reject" />
                )
            }
            {
                !props.haveDataRequired && (
                    <FormResponseMessage
                        LeftWrapper="col-sm-3"
                        CenterWrapper="col-sm-12 mt-15 mb-15"
                        MessageStyle="formResponseMessage-reject"
                        Message={'Failed to create policy schedule pdf file. Try again later.'}
                    />
                )
            }
            {
                isGpl && (
                    /* The document list is fetched by the modal itself on open, not here. It was a
                       mount effect in this component until PR 16621 review: keyed on [isGpl], it
                       fired exactly once, so a failed list request could never be retried. */
                    <GplWordingModal
                        isOpen={isWordingModalOpen}
                        onClose={() => setWordingModalOpen(false)}
                        documents={gplDocuments.documents}
                        fetching={gplDocuments.fetching}
                        failed={gplDocuments.failed}
                        documentToDownload={gplDocuments.documentToDownload}
                        fetchingDocument={gplDocuments.fetchingDocument}
                        failedToGetDocument={gplDocuments.failedToGetDocument}
                    />
                )
            }
		</div>
	)
};

export default PolicyTab;